import { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { GateAddModal } from "../GateAddModal/GateAddModal";
import { GateConfirmModal } from "../GateConfirmModal/GateConfirmModal";
import { useAuth } from "../../../../auth";

const GateListModalForm = ({
  listing,
  selectedListingId,
  setOpenGateListModal,
  setOpenTimelineModal,
  openGateAddModal,
  setOpenGateAddModal,
  gateLists,
  getGateLists
}) => {
  const { currentUser, haveAccess } = useAuth();
  const [device, setDevice] = useState(null)
  const [openGateConfirmModal, setOpenGateConfirmModal] = useState(false)

  return (
    <>
      <div className="kt_body">
        {haveAccess(currentUser, "listing_tracker_logs_list") && <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {listing?.gate_allowed && <button className="btn btn-sm btn-info mb-4 mt-0 text-white" onClick={() => {
            setOpenTimelineModal(true)
          }}>Show Logs</button>}
        </div>
        }
        {!!gateLists?.length ? <div style={{ maxHeight: '240px', overflowY: 'auto', minHeight: 'auto', display: 'grid', gap: '10px', gridTemplateColumns: '1fr 1fr' }}>
          <>
            {gateLists?.map((item, index) => (
              <div
                className="d-flex flex-column p-3"
                key={index}
                style={{
                  background: item.is_active ? "#e3feee9e" : "#f9f9f9",
                  borderRadius: "10px",
                }}
              >
                <div className="d-flex justify-content-between">
                  <div className="w-50">
                    <label className="fw-bold fs-6 mb-2">Device ID</label>
                    <h5 className="text-main fw-bolder">{item.device_id}</h5>
                  </div>
                  <div className="w-50 text-end">
                    <label className="fw-bold fs-6 mb-2">Device Label</label>
                    <h5 className="text-main fw-bolder">{item.device_label}</h5>
                  </div>
                </div>

                <div className="d-flex justify-content-between mt-3">
                  <div className="w-50">
                    <label className="fw-bold fs-6 mb-2">Connection</label>
                    <h5 className={`${item.is_online ? "text-success" : "text-danger"} fw-bolder`}>{item.hasOwnProperty('is_online') ? item.is_online ? "Online" : "Offline" : 'Not Found'}</h5>
                  </div>
                  <div className="w-50 text-end">
                    <label className="fw-bold fs-6 mb-2">Status</label>
                    <h5 className={`${item.is_active ? "text-success" : "text-danger"} fw-bolder`}>{item.is_active ? "Enabled" : "Disabled"}</h5>
                  </div>
                </div>
                <div className="w-50">
                    <label className="fw-bold fs-6 mb-2">Created At</label>
                    <h5 className="text-main fw-bolder">
                      {moment(item.createdAt).utc().format("YYYY-MM-DD")}
                    </h5>
                </div>
                {(haveAccess(currentUser, "gate_access_control")) && (
                  <div className="d-flex justify-content-between mt-3">
                    <div className="w-50">
                      <button
                        className="btn btn-success btn-sm text-white"
                        disabled={!item.is_active}
                        onClick={() => {
                          setDevice({ ...item, type: 'open' });
                          setOpenGateConfirmModal(true);
                        }}
                      >
                        Open Gate
                      </button>
                    </div>
                    <div className="w-50 text-end">
                     <button
                      className={`btn btn-info btn-sm text-white`}
                      disabled={!haveAccess(currentUser, "gate_access_add_device")}
                      onClick={() => {
                        setDevice(item);
                        setOpenGateAddModal(true);
                      }}
                    >
                      Edit Gate
                    </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </>

        </div>
          :
          <h4 className="text-center">No Gates list to display</h4>
        }
        <div className="text-center pt-5">
          <button
            type="button"
            className="btn mt-4 btn-primary text-white"
            onClick={() => {
              setOpenGateListModal(false)
              setOpenTimelineModal(false)
            }}
          >
            Go Back
          </button>
          {(haveAccess(currentUser, "gate_access_add_device")) && 
          <button className="btn btn-success align-self-start mt-4 mx-4" 
          onClick={() => setOpenGateAddModal(true)}>
            Add New Gate
          </button>
          }
        </div>
      </div>
      {openGateAddModal &&
        <GateAddModal
          device={device}
          setDevice={setDevice}
          setOpenGateAddModal={setOpenGateAddModal}
          getGateLists={getGateLists}
          listing={listing}
        />
      }
      {openGateConfirmModal &&
        <GateConfirmModal
          device={device}
          setDevice={setDevice}
          setOpenGateConfirmModal={setOpenGateConfirmModal}
          getGateLists={getGateLists}
          listing={listing}
        />
      }
    </>
  );
};

export { GateListModalForm };
